var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _circle, _circle2, _path36, _rect, _path37, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedNoSummary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 105,
    viewBox: "0 0 344 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23375 24C3.23375 23.3186 2.68138 22.7662 2 22.7662C1.31862 22.7662 0.766247 23.3186 0.766247 24H3.23375ZM2 84H3.23375L3.23375 24H2H0.766247L0.766247 84H2Z",
    fill: "url(#paint0_linear_2055_10340)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2338 20C13.2338 19.3186 12.6814 18.7663 12 18.7663C11.3186 18.7663 10.7662 19.3186 10.7662 20H13.2338ZM12 84H13.2338L13.2338 20H12H10.7662L10.7662 84H12Z",
    fill: "url(#paint1_linear_2055_10340)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2338 16C23.2338 15.3186 22.6814 14.7663 22 14.7663C21.3186 14.7663 20.7662 15.3186 20.7662 16H23.2338ZM22 84H23.2338L23.2338 16H22H20.7662L20.7662 84H22Z",
    fill: "url(#paint2_linear_2055_10340)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2338 11.5848C33.2338 10.9034 32.6814 10.351 32 10.351C31.3186 10.351 30.7662 10.9034 30.7662 11.5848H33.2338ZM32 84H33.2338L33.2338 11.5848H32H30.7662L30.7662 84H32Z",
    fill: "url(#paint3_linear_2055_10340)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2338 8.65623C43.2338 7.97485 42.6814 7.42249 42 7.42249C41.3186 7.42249 40.7662 7.97485 40.7662 8.65623H43.2338ZM42 84H43.2338L43.2338 8.65623H42H40.7662L40.7662 84H42Z",
    fill: "url(#paint4_linear_2055_10340)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2338 6.26015C53.2338 5.57877 52.6814 5.0264 52 5.0264C51.3186 5.0264 50.7662 5.57877 50.7662 6.26015H53.2338ZM52 84H53.2338L53.2338 6.26015H52H50.7662L50.7662 84H52Z",
    fill: "url(#paint5_linear_2055_10340)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2338 4.39652C63.2338 3.71514 62.6814 3.16277 62 3.16277C61.3186 3.16277 60.7662 3.71514 60.7662 4.39652H63.2338ZM62 84H63.2338L63.2338 4.39652H62H60.7662L60.7662 84H62Z",
    fill: "url(#paint6_linear_2055_10340)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2338 3.06536C73.2338 2.38397 72.6814 1.8316 72 1.8316C71.3186 1.8316 70.7662 2.38397 70.7662 3.06536H73.2338ZM72 84H73.2338L73.2338 3.06536H72H70.7662L70.7662 84H72Z",
    fill: "url(#paint7_linear_2055_10340)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2338 2C83.2338 1.31862 82.6814 0.766251 82 0.766251C81.3186 0.766251 80.7662 1.31862 80.7662 2H83.2338ZM82 84H83.2338V2H82H80.7662V84H82Z",
    fill: "url(#paint8_linear_2055_10340)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2338 2.00043C93.2338 1.31905 92.6814 0.766678 92 0.766678C91.3186 0.766678 90.7662 1.31905 90.7662 2.00043H93.2338ZM92 84H93.2338L93.2338 2.00043H92H90.7662L90.7662 84H92Z",
    fill: "url(#paint9_linear_2055_10340)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.234 3.06536C103.234 2.38397 102.681 1.8316 102 1.8316C101.319 1.8316 100.766 2.38397 100.766 3.06536H103.234ZM102 84H103.234L103.234 3.06536H102H100.766L100.766 84H102Z",
    fill: "url(#paint10_linear_2055_10340)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.234 4.92899C113.234 4.2476 112.681 3.69523 112 3.69523C111.319 3.69523 110.766 4.2476 110.766 4.92899H113.234ZM112 84H113.234L113.234 4.92899H112H110.766L110.766 84H112Z",
    fill: "url(#paint11_linear_2055_10340)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.234 7.85754C123.234 7.17616 122.681 6.62379 122 6.62379C121.319 6.62379 120.766 7.17616 120.766 7.85754H123.234ZM122 84H123.234L123.234 7.85754H122H120.766L120.766 84H122Z",
    fill: "url(#paint12_linear_2055_10340)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.234 11.0522C133.234 10.3708 132.681 9.81846 132 9.81846C131.319 9.81846 130.766 10.3708 130.766 11.0522H133.234ZM132 84H133.234V11.0522H132H130.766V84H132Z",
    fill: "url(#paint13_linear_2055_10340)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M143.234 15.3119C143.234 14.6305 142.681 14.0782 142 14.0782C141.319 14.0782 140.766 14.6305 140.766 15.3119H143.234ZM142 84H143.234L143.234 15.3119H142H140.766L140.766 84H142Z",
    fill: "url(#paint14_linear_2055_10340)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.234 19.0393C153.234 18.3579 152.681 17.8055 152 17.8055C151.319 17.8055 150.766 18.3579 150.766 19.0393H153.234ZM152 84H153.234V19.0393H152H150.766V84H152Z",
    fill: "url(#paint15_linear_2055_10340)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M163.234 22.2341C163.234 21.5527 162.681 21.0003 162 21.0003C161.319 21.0003 160.766 21.5527 160.766 22.2341H163.234ZM162 84H163.234V22.2341H162H160.766V84H162Z",
    fill: "url(#paint16_linear_2055_10340)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M173.234 24.364C173.234 23.6826 172.681 23.1302 172 23.1302C171.319 23.1302 170.766 23.6826 170.766 24.364H173.234ZM172 84H173.234L173.234 24.364H172H170.766L170.766 84H172Z",
    fill: "url(#paint17_linear_2055_10340)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M183.234 25.4289C183.234 24.7475 182.681 24.1951 182 24.1951C181.319 24.1951 180.766 24.7475 180.766 25.4289H183.234ZM182 84H183.234V25.4289H182H180.766V84H182Z",
    fill: "url(#paint18_linear_2055_10340)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M193.234 25.9613C193.234 25.28 192.681 24.7276 192 24.7276C191.319 24.7276 190.766 25.28 190.766 25.9613H193.234ZM192 84H193.234L193.234 25.9613H192H190.766L190.766 84H192Z",
    fill: "url(#paint19_linear_2055_10340)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M203.234 26.2276C203.234 25.5462 202.681 24.9938 202 24.9938C201.319 24.9938 200.766 25.5462 200.766 26.2276H203.234ZM202 84H203.234V26.2276H202H200.766V84H202Z",
    fill: "url(#paint20_linear_2055_10340)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M213.234 25.9612C213.234 25.2798 212.681 24.7274 212 24.7274C211.319 24.7274 210.766 25.2798 210.766 25.9612H213.234ZM212 84H213.234L213.234 25.9612H212H210.766L210.766 84H212Z",
    fill: "url(#paint21_linear_2055_10340)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M223.234 25.6951C223.234 25.0137 222.681 24.4614 222 24.4614C221.319 24.4614 220.766 25.0137 220.766 25.6951H223.234ZM222 84H223.234V25.6951H222H220.766V84H222Z",
    fill: "url(#paint22_linear_2055_10340)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M233.234 25.1626C233.234 24.4813 232.681 23.9289 232 23.9289C231.319 23.9289 230.766 24.4813 230.766 25.1626H233.234ZM232 84H233.234V25.1626H232H230.766V84H232Z",
    fill: "url(#paint23_linear_2055_10340)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M240.766 24.6302C240.766 23.9488 241.319 23.3964 242 23.3964C242.681 23.3964 243.234 23.9488 243.234 24.6302H240.766ZM242 84H240.766V24.6302H242H243.234V84H242Z",
    fill: "url(#paint24_linear_2055_10340)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M250.766 24.0977C250.766 23.4163 251.319 22.864 252 22.864C252.681 22.864 253.234 23.4163 253.234 24.0977H250.766ZM252 84H250.766V24.0977H252H253.234V84H252Z",
    fill: "url(#paint25_linear_2055_10340)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M263.234 23.8315C263.234 23.1501 262.681 22.5977 262 22.5977C261.319 22.5977 260.766 23.1501 260.766 23.8315H263.234ZM262 84H263.234V23.8315H262H260.766V84H262Z",
    fill: "url(#paint26_linear_2055_10340)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M273.234 23.5653C273.234 22.8839 272.681 22.3315 272 22.3315C271.319 22.3315 270.766 22.8839 270.766 23.5653H273.234ZM272 84H273.234V23.5653H272H270.766V84H272Z",
    fill: "url(#paint27_linear_2055_10340)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M280.766 24.0977C280.766 23.4163 281.319 22.864 282 22.864C282.681 22.864 283.234 23.4163 283.234 24.0977H280.766ZM282 84H280.766V24.0977H282H283.234V84H282Z",
    fill: "url(#paint28_linear_2055_10340)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M293.234 24.8964C293.234 24.215 292.681 23.6627 292 23.6627C291.319 23.6627 290.766 24.215 290.766 24.8964H293.234ZM292 84H293.234V24.8964H292H290.766V84H292Z",
    fill: "url(#paint29_linear_2055_10340)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M303.234 26C303.234 25.3186 302.681 24.7662 302 24.7662C301.319 24.7662 300.766 25.3186 300.766 26H303.234ZM302 84H303.234L303.234 26H302H300.766L300.766 84H302Z",
    fill: "url(#paint30_linear_2055_10340)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M313.234 27C313.234 26.3186 312.681 25.7662 312 25.7662C311.319 25.7662 310.766 26.3186 310.766 27H313.234ZM312 84H313.234V27H312H310.766V84H312Z",
    fill: "url(#paint31_linear_2055_10340)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M323.234 28C323.234 27.3186 322.681 26.7662 322 26.7662C321.319 26.7662 320.766 27.3186 320.766 28H323.234ZM322 84H323.234V28H322H320.766V84H322Z",
    fill: "url(#paint32_linear_2055_10340)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M333.234 30C333.234 29.3186 332.681 28.7662 332 28.7662C331.319 28.7662 330.766 29.3186 330.766 30H333.234ZM332 84H333.234V30H332H330.766V84H332Z",
    fill: "url(#paint33_linear_2055_10340)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M343.234 32C343.234 31.3186 342.681 30.7662 342 30.7662C341.319 30.7662 340.766 31.3186 340.766 32H343.234ZM342 84H343.234V32H342H340.766V84H342Z",
    fill: "url(#paint34_linear_2055_10340)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 73,
    r: 32,
    fill: "#FFF6FB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 73,
    r: 30,
    fill: "#E04B9F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6798 76.4995H80.851C80.3647 76.4995 80 76.8173 80 77.2318C80 77.6601 80.3647 77.9917 80.851 77.9917H89.6798C90.1509 77.9917 90.5003 77.6601 90.5003 77.2318C90.5003 76.8173 90.1509 76.4995 89.6798 76.4995ZM89.6798 80.2575H80.851C80.3647 80.2575 80 80.5891 80 81.0174C80 81.4319 80.3647 81.7497 80.851 81.7497H89.6798C90.1509 81.7497 90.5003 81.4319 90.5003 81.0174C90.5003 80.5891 90.1509 80.2575 89.6798 80.2575Z",
    fill: "#FFF6FB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.8789,
    y: 59.8789,
    width: 20.2421,
    height: 26.2418,
    rx: 2.63679,
    stroke: "#FFF6FB",
    strokeWidth: 1.75786
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9752 73L84.2861 70.7781H80.9532L80.2923 73H78.0844L81.5157 63.2544H83.8361L87.2674 73H84.9752ZM81.4032 69.2593H83.8502L82.6126 65.181L81.4032 69.2593ZM88.393 73V65.8139H90.4462V73H88.393ZM89.4196 64.7029C89.0634 64.7029 88.7774 64.6045 88.5618 64.4076C88.3461 64.2107 88.2383 63.9435 88.2383 63.606C88.2383 63.2685 88.3461 63.0013 88.5618 62.8044C88.7774 62.6075 89.0634 62.5091 89.4196 62.5091C89.7759 62.5091 90.0618 62.6075 90.2775 62.8044C90.4931 63.0013 90.6009 63.2685 90.6009 63.606C90.6009 63.9435 90.4931 64.2107 90.2775 64.4076C90.0618 64.6045 89.7759 64.7029 89.4196 64.7029Z",
    fill: "#FFF6FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2055_10340",
    x1: 2.5,
    y1: 24,
    x2: 2.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2055_10340",
    x1: 12.5,
    y1: 20,
    x2: 12.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2055_10340",
    x1: 22.5,
    y1: 16,
    x2: 22.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2055_10340",
    x1: 32.5,
    y1: 11.5848,
    x2: 32.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2055_10340",
    x1: 42.5,
    y1: 8.65623,
    x2: 42.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2055_10340",
    x1: 52.5,
    y1: 6.26015,
    x2: 52.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2055_10340",
    x1: 62.5,
    y1: 4.39652,
    x2: 62.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2055_10340",
    x1: 72.5,
    y1: 3.06536,
    x2: 72.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2055_10340",
    x1: 82.5,
    y1: 2,
    x2: 82.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2055_10340",
    x1: 92.5,
    y1: 2.00043,
    x2: 92.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2055_10340",
    x1: 102.5,
    y1: 3.06536,
    x2: 102.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2055_10340",
    x1: 112.5,
    y1: 4.92899,
    x2: 112.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2055_10340",
    x1: 122.5,
    y1: 7.85754,
    x2: 122.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2055_10340",
    x1: 132.5,
    y1: 11.0522,
    x2: 132.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2055_10340",
    x1: 142.5,
    y1: 15.3119,
    x2: 142.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2055_10340",
    x1: 152.5,
    y1: 19.0393,
    x2: 152.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2055_10340",
    x1: 162.5,
    y1: 22.2341,
    x2: 162.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2055_10340",
    x1: 172.5,
    y1: 24.364,
    x2: 172.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2055_10340",
    x1: 182.5,
    y1: 25.4289,
    x2: 182.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2055_10340",
    x1: 192.5,
    y1: 25.9613,
    x2: 192.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2055_10340",
    x1: 202.5,
    y1: 26.2276,
    x2: 202.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2055_10340",
    x1: 212.5,
    y1: 25.9612,
    x2: 212.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2055_10340",
    x1: 222.5,
    y1: 25.6951,
    x2: 222.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2055_10340",
    x1: 232.5,
    y1: 25.1626,
    x2: 232.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2055_10340",
    x1: 241.5,
    y1: 24.6302,
    x2: 241.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2055_10340",
    x1: 251.5,
    y1: 24.0977,
    x2: 251.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2055_10340",
    x1: 262.5,
    y1: 23.8315,
    x2: 262.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2055_10340",
    x1: 272.5,
    y1: 23.5653,
    x2: 272.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2055_10340",
    x1: 281.5,
    y1: 24.0977,
    x2: 281.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2055_10340",
    x1: 292.5,
    y1: 24.8964,
    x2: 292.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2055_10340",
    x1: 302.5,
    y1: 26,
    x2: 302.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2055_10340",
    x1: 312.5,
    y1: 27,
    x2: 312.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2055_10340",
    x1: 322.5,
    y1: 28,
    x2: 322.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2055_10340",
    x1: 332.5,
    y1: 30,
    x2: 332.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2055_10340",
    x1: 342.5,
    y1: 32,
    x2: 342.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedNoSummary);
export default __webpack_public_path__ + "static/media/red_no_summary.5da30696c721c9b1e006e371d4a92576.svg";
export { ForwardRef as ReactComponent };